export default __webpack_public_path__ + "static/media/OMSC_07.60610753.gif";